module.exports = __webpack_public_path__ + "img/banner-003.f86ba002.png";